import { Space } from '@/shared/types/Space';

export const sortSpaces = (spaces: Space[]) => {
  return spaces.sort((a, b) => {
    if (a.is_default) {
      return -1;
    }

    if (b.is_default) {
      return 1;
    }

    return a.name.localeCompare(b.name, undefined, { numeric: true });
  });
};
